let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1c4TZ"), load("cplyI"), load("avCUM"), load("dH2J7"), load("gQSWJ"), load("3L8bY"), load("3YiRE")]).then(() => parcelRequire('iR5x9'));